import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { sortBy } from 'lodash';

import ApiServiceServerless from '../../../xhr_libs';
import SmallerLoader from '../../SmallerLoader';

const CSV_PAYLOAD_OPTS = {
  headers: {
    Accept: 'application/vnd.openxmlformats-',
    'Content-Type': 'application/json',
  },
  responseType: 'arraybuffer',
};

export default function PlugMeterReportModal(props) {
  const { show, onHide, allCredentials, organizationId } = props;

  const [credentialId, setCredentialId] = useState('');


  const [isGeneratingReport, setIsGeneratingReport] = useState(false);


  const handleSetReport = (url, fileName) => {
    const old_link = document.getElementById('report-download-link');
    if (old_link) {
      old_link.remove();
    }
    const link = document.createElement('a');
    link.href = url;
    link.id = 'report-download-link';
    link.target = '_blank';
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  };

  const downloadReport = () => {
    setIsGeneratingReport(true);

    const fileName = `Meter Report.xlsx`;

    ApiServiceServerless.post(
      'reports/excel_plug_meter',

      {
        credential_id: credentialId,
      },
      { ...CSV_PAYLOAD_OPTS, authorization_id: organizationId }
    )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        handleSetReport(url, fileName);
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        setIsGeneratingReport(false);
        onHide();
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton={!isGeneratingReport}>
        Download Meter Data
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={10}>
            <Form.Group>
              <Form.Label>Credential</Form.Label>
              <Form.Control
                as='select'
                onChange={(e) => setCredentialId(e.target.value)}
                value={credentialId}
              >
                <option key={''} value={''} hidden>
                  {''}
                </option>
                {sortBy(allCredentials, ['utilityProvider']).map((cred) => (
                  <option key={cred['id']} value={cred['id']}>
                    {cred['utilityProvider'] + " - " + cred['username']}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          onClick={() => downloadReport()}
          disabled={
            !credentialId ||
            isGeneratingReport

          }
        >
          {isGeneratingReport && <SmallerLoader text={'Generating...'} />}
          {!isGeneratingReport && <> Download Report</>}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
